<app-game-header/>

<!-- <app-notepad></app-notepad> -->
<div class="relative h-dvh w-dvw bg-black overflow-hidden" id="game-container" #gameContainer>
  <!-- Тут появится canvas от Pixi -->
</div>

<div class="gradient" id="trap-overflow"></div>